import React from 'react';
import { Col, Form } from 'react-bootstrap';
import MultiSelect from '../../MultiSelect';
import { platformToCategoryMap, subPlatformOptions } from '../../../../static-data/configDropdownOptions';
import { formatCountryOptions } from '../../../../static-data/formatCountryOptions'; 
const PlatformSelection = ({
  platforms,
  subPlatforms,
  browsers,
  projectConfig,
  isEditing,
  setFieldValue,
  isCycleCompleted,
  geographies,
  isPlatformRequired = true,
  browserOptions,
}) => {
  const getFilteredSubPlatforms = (platforms) => {
    const selectedPlatforms = platforms || [];
    const savedSubPlatforms = projectConfig?.sub_platforms || [];

    const selectedCategories = selectedPlatforms
      .map((platform) => platformToCategoryMap[platform])
      .filter(Boolean);

    if (!selectedCategories.length) return [];

    return subPlatformOptions
      .filter(
        (option) =>
          selectedCategories.includes(option.category) &&
          savedSubPlatforms.includes(option.name)
      )
      .map((option) => option.name);
  };

  const hasCompatiblePlatform = platforms?.some((platform) =>
    ['Web', 'Mobile Responsive', 'Native Mobile App', 'Hybrid Mobile App'].includes(platform)
  );

  const handlePlatformChange = (selectedPlatforms) => {
    setFieldValue('platforms', selectedPlatforms);

    const filteredSubPlatforms = getFilteredSubPlatforms(selectedPlatforms);
    const updatedSubPlatforms = subPlatforms.filter((subPlatform) =>
      filteredSubPlatforms.includes(subPlatform)
    );

    setFieldValue('subPlatforms', updatedSubPlatforms);

    if (!selectedPlatforms.some((platform) => platformToCategoryMap[platform])) {
      setFieldValue('browsers', []);
    }
  };

  const filteredSubPlatformOptions = getFilteredSubPlatforms(platforms);

  return (
    <>
      {projectConfig?.platforms?.length > 0 && (
        <Col md={4}>
          <Form.Group controlId="platforms">
            <Form.Label className={isPlatformRequired ? 'required' : ''}>Testing Platform</Form.Label>
            {isEditing && !isCycleCompleted ? (
              <MultiSelect
                options={projectConfig.platforms}
                selectedValues={platforms || []}
                onChange={handlePlatformChange}
                placeholder="Select platforms"
              />
            ) : (
              <p className="form-static-text">
                {platforms?.join(', ') || 'None'}
              </p>
            )}
          </Form.Group>
        </Col>
      )}

      {projectConfig?.sub_platforms?.length > 0 &&
        filteredSubPlatformOptions?.length > 0 && (
          <Col md={4}>
            <Form.Group controlId="subPlatformOptions">
              <Form.Label className={isPlatformRequired ? 'required' : ''}>Supported Options</Form.Label>
              {isEditing && !isCycleCompleted ? (
                <MultiSelect
                  options={filteredSubPlatformOptions}
                  selectedValues={subPlatforms || []}
                  onChange={(value) => setFieldValue('subPlatforms', value)}
                  placeholder="Select sub-platforms"
                />
              ) : (
                <p className="form-static-text">
                  {subPlatforms?.join(', ') || 'None'}
                </p>
              )}
            </Form.Group>
          </Col>
        )}

      {hasCompatiblePlatform && browserOptions?.length > 0 && (
        <Col md={4}>
          <Form.Group controlId="browsers">
            <Form.Label>Browsers</Form.Label>
            {isEditing && !isCycleCompleted ? (
              <MultiSelect
                options={browserOptions}
                selectedValues={browsers || []}
                onChange={(value) => setFieldValue('browsers', value)}
                placeholder="Select browsers"
              />
            ) : (
              <p className="form-static-text">
                {browsers?.join(', ') || 'None'}
              </p>
            )}
          </Form.Group>
        </Col>
      )}
      {projectConfig?.multiple_geographies === 'Yes' &&
       projectConfig?.geographies?.length > 0 && (
       <Col md={4}>
      <Form.Group controlId="geographies">
        <Form.Label>Countries</Form.Label>
        {isEditing && !isCycleCompleted ? (
          (() => {
            const formatted = formatCountryOptions(projectConfig.geographies);
            const displayMap = {};
            formatted.forEach(item => {
              displayMap[item.value] = item.display;
            });

            return (
              <MultiSelect
                options={projectConfig?.geographies}
                selectedValues={geographies || []}
                onChange={(value) => setFieldValue('geographies', value)}
                placeholder="Select countries"
                renderOption={(option) => displayMap[option]}
              />
            );
          })()
        ) : (
          <p className="form-static-text">
            {geographies?.length > 0 ? geographies.join(', ') : 'None'}
          </p>
        )}
       </Form.Group>
       </Col>
     )}
    </>
  );
};

export default PlatformSelection;
